mp.tooltip = {
    init: function () {
        $('[data-toggle="tooltip"]').tooltip();
    }
};

$(document).ready(function () {
    mp.tooltip.init();
});